import React, { Component } from "react";
import styled from 'styled-components';
import axios from "axios";
import ClientDropDown from '../dropdown/ClientDropDown';
import AdminDropDown from '../dropdown/AdminDropDown';
import DimensionDropDown from '../dropdown/DimensionDropDown';
import LineGraphDaily from '../linegraph/LineGraphDaily';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logoutUser } from "../../actions/authActions";
import "./Landing.css";
import Logo from '../assets/Sclogo.svg';
import DaysLeftIcon from '../assets/icons/Days-left.svg';
import ExpireDateIcon from '../assets/icons/Expire-Date.svg';
import ProductNameIcon from '../assets/icons/Product-Name.svg';
import LogoutIcon from '../assets/icons/logout.svg';
import DateRangePickerWrapper from '../datepicker/DateRangePicker';
import API_URL from '../../config';

class Landing extends Component {
    constructor() {
        super();
        var today = new Date(),
            date = (today.getMonth() + 1) + '-' + today.getDate() + '-' + today.getFullYear()
        let last30days = new Date(today.getTime());
        last30days.setDate(last30days.getDate() - 30);
        this.state = {
            userInfo: [],
            setGraph: true,
            checkAdmin: false,
            currentDate: date,
            usersList: [],
            dimension: [],
            selectedUser: undefined,
            selectedProduct: undefined,
            usageData: [],
            initialDateRange: {
                startDate: last30days,
                endDate: today
            }
        }
        console.log(this.state.initialDateRange);
    }

    onLogoutClick = e => {
        e.preventDefault();
        this.props.logoutUser();
    };

    componentDidMount() {
        const { user } = this.props.auth;
        const payload = {
            "customerId": user.customerId
        }

        if (user.role == 'admin') {
            axios
            .get(API_URL + "/getUsers")
            .then((response) => {
                return this.setState({ usersList: response.data.user}, () => this.state.usersList.map(u => console.log("~~U~~~", u, "~~~~~")))
            })
            .catch((error) => {
                console.log("++err++", error)
            });
        } else {
            console.log(user);
            axios
            .post(API_URL + "/getProduct", payload)
            .then((response) => {
                console.log(response.data.user[0]);
                return this.setState({ selectedUser: response.data.user[0] }, () => this.state.userInfo.map(e => console.log("~~E~~~", e, "~~~~~")))
            })
            .catch((error) => {
                console.log("++err++", error)
            });
        }
    }
    adminDropdownSelected(user, product) {
        this.getDimensions(product);
        this.setState({
            selectedUser: user,
            selectedProduct: product
        });
    }
    dropDownSelected(product) {
        this.getDimensions(product);
        this.setState({
            selectedProduct: product
        });
    }
    getDimensions(product) {
        axios.get(API_URL + "/products/" + product.code).then((res) => {
            if (res.data && res.data.product && res.data.product.dimensions && res.data.product.dimensions.length > 0) {
                this.setState({
                    dimensions: res.data.product.dimensions
                });
            }
        })
    }
    dateConvertor(date) {
        let twoDigits = (num) => num > 9? num: "0" + num;
        return date.getFullYear() + "-" + twoDigits(date.getMonth() + 1) + "-" + twoDigits(date.getDate());
    }
    getUsageData() {
        let url = API_URL + '/meter';
        const { user } = this.props.auth;
        let initialDateRange = this.state.initialDateRange;
        let startDate = new Date(initialDateRange.startDate.getTime());
        let endDate = new Date(initialDateRange.endDate.getTime());
        let params = {
            customer: this.state.selectedUser.customerId,
            productCode: this.state.selectedProduct.code,
            dimension: this.state.selectedDimension.name,
            granularity: this.state.setGraph? "day": "month",
            start: this.dateConvertor(startDate) + "T00:00:00Z",
            end: this.dateConvertor(endDate)  + "T23:00:00Z"
        };

        if(user.role != 'admin'){
            url+='/me';
            delete params.customer;
        }   
        axios.get(url, {
            params
        }).then(res => {
            console.log(res);
            let data = []
            if (res.data && res.data.meters && res.data.meters.length > 0) {
                data = res.data.meters;
            } 
            this.setState({
                usageData: data
            })
        });
    }
    dimensionDropdown(dimension) {
        console.log("Dimesion")
        this.setState({
            selectedDimension: dimension,
            usageData: []
        }, this.getUsageData.bind(this));
    }
    changeGraphType(value) {
        let initialDateRange = {};
        if (value) {
            let today = new Date();
            let last30days = new Date(today.getTime());;
            last30days.setDate(last30days.getDate() - 30);
            initialDateRange.startDate = last30days;
            initialDateRange.endDate = today;
        } else {
            let today = new Date();
            let last3Month = new Date(today.getTime());;
            last3Month.setMonth(last3Month.getMonth() - 3);
            last3Month.setDate(1);
            console.log(last3Month);
            initialDateRange.startDate = last3Month;
            initialDateRange.endDate = today;
        }
        this.setState({ setGraph: value, initialDateRange }, this.dimensionDropdown.bind(this, this.state.selectedDimension)); ;
    }
    dateRangeChanged(range) {
        console.log(range);
        this.setState({
            initialDateRange: range
        }, this.dimensionDropdown.bind(this, this.state.selectedDimension));
    }
    // dropDownSelected(selectedProduct) {
    //     this.setState({ sp: this.state.userInfo.find(e => e._id == selectedProduct.value) })
    //     this.setState({ spp: this.state.usersList.find(e => e._id == selectedProduct.value) })
    // }

    render() {
        const { user } = this.props.auth;
        const { userInfo, usersList } = this.state;
        // let whoIam =  user.firstname == 'Admin' ? this.state.spp : this.state.sp;
        // const { productname } = whoIam;
        let formHide = { visibility: user.role ? 'visible' : 'hidden' }
        let formUnHide = { visibility: user.role ? 'hidden' : 'visible' }
        let productDesc, currentDate, productExpireDate, countDown = 0;
        if (this.state.selectedProduct) {
            if (this.state.selectedProduct.name == "Analytics Shift") {
                productDesc = "Analytics Shift immediately brings your Adobe Analytics data into AWS Redshift. Shift allows for data ownership, backup and storage of your Adobe Analytics data as a queryable entity.";
            } else {
                productDesc = "Boomerang is Softcrylic's lightweight, flexible technology for identifying audiences from digital behaviors that signal high intent. Familiar examples of high-intent behavioral signals are search and cart abandonment, but there are others that are specific to your customers and your business.";
            }
            
            currentDate = new Date(this.state.currentDate);
            productExpireDate = new Date(this.state.selectedProduct.expiryDate);

            let diffInMs = productExpireDate - currentDate;
            countDown = (diffInMs / (1000 * 60 * 60 * 24)).toFixed();
        }

        return (
            <div className="landingContainer">
                <div className="header">
                    <img src={Logo} alt="" />
                    <p className="title">Softcrylic Product Console</p>
                    <div className="welcomeText">
                        <p>Welcome {user.firstname.split(" ")[0]}</p>
                        <img src={LogoutIcon} className="logout"  onClick={this.onLogoutClick} alt="Logout" />
                    </div>
                </div>
                <div className="content">
                    <div className="firstRow">
                        <div className="products">
                            { user.role == 'admin' ?
                                <AdminDropDown
                                    name={user.role}
                                    dropDownSelected={this.adminDropdownSelected.bind(this)}
                                    usersList={usersList}
                                /> :
                                <ClientDropDown
                                    name={user.role}
                                    dropDownSelected={this.dropDownSelected.bind(this)}
                                    productList={this.state.selectedUser?.products}
                                />}
                                
                            <div className="productInfo">
                                <div className="left">
                                    <img src={ProductNameIcon} alt="" ></img>
                                    <div className="label">Product Name:</div>
                                    <div className="value">{this.state.selectedProduct?.name}</div>
                                </div>
                                <div className="center">
                                    <img src={ExpireDateIcon} alt="" ></img>
                                    <div className="label">Expire Date:</div>
                                    <div className="value">{this.state.selectedProduct?.expiryDate}</div>
                                </div>
                                <div className="right">
                                    <img src={DaysLeftIcon} alt="" ></img>
                                    <div className="label">Days Left:</div>
                                    <div className="value">{countDown < 1? "Expired": countDown}</div>
                                </div>
                            </div>
                            <div className="description">
                                <span>Description: </span>
                                {productDesc}
                            </div>
                        </div>
                        <div className="otherProducts">
                            <div className="title">Our Other Products</div>
                            <div className="underline"></div>
                            <div>
                                <div className="link"><div className="dot"></div><a href="https://aws.amazon.com/marketplace/pp/B08WCL3DP1" target="_blank">Analytics Shift</a></div>
                                <div className="link"><div className="dot"></div><a href="https://aws.amazon.com/marketplace/pp/B08XY6QLH2" target="_blank">Boomerang</a></div>
                            </div>
                        </div>
                    </div>
                    <div className="secondRow">
                        <div className="title">Usage Information</div>
                        <div className="underline"></div>
                        <div className="controls">
                            <DimensionDropDown className="monthFilter" dropDownSelected={this.dimensionDropdown.bind(this)} dimensions={this.state.dimensions} />
                            <div className="options">
                                <div className={`option ${this.state.setGraph ? "selected" : ""}`} onClick={this.changeGraphType.bind(this, true)}>
                                    Daily Report
                                </div>
                                <div className={`option ${!this.state.setGraph ? "selected" : ""}`} onClick={this.changeGraphType.bind(this, false)}>
                                    Monthly Report
                                </div>
                            </div>
                            <div className="calender">
                                <DateRangePickerWrapper dateRangeChanged={this.dateRangeChanged.bind(this)} initialDateRange={this.state.initialDateRange}></DateRangePickerWrapper>
                            </div>
                        </div>
                        <div className="graph">
                            <LineGraphDaily data={this.state.usageData} dimension={this.state.selectedDimension} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
Landing.propTypes = {
    logoutUser: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
    auth: state.auth
});
export default connect(
    mapStateToProps,
    { logoutUser }
)(Landing);
